import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import {
  SelectFieldV2,
  TextAreaField,
  SubmitButton,
  CancelPopupButton,
} from 'ui/FormElement';
import { Formik, Form } from 'formik';

import coachInvoiceTypes from 'data/coach_invoice_types';
import { useContext } from '../Context';

function getFilteredTypes(row) {
  const compareTypes = ['general', 'executive', 'pro_bono'];

  if (compareTypes.includes(row.attributes.invoice_type)) {
    return coachInvoiceTypes.filter((item) => compareTypes.includes(item.value));
  }
  return coachInvoiceTypes.filter((item) => !compareTypes.includes(item.value));
}

export default function EditForm({ row, onHide }) {
  const FormSchema = Yup.object().shape({
    invoiceType: Yup.string()
      .required('Choose Policy Template'),
  });

  const { dispatch, actions } = useContext();

  const types = getFilteredTypes(row);

  const onSubmit = (values, { setSubmitting }) => {
    actions.update(
      dispatch,
      row.id,
      {
        new_type: values.invoiceType,
        notice: values.note,
      },
      () => {
        setSubmitting(false);
        onHide();
      },
    );
  };

  return (

    <Formik
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={{
        invoiceType: row.attributes.invoice_type,
        note: row.attributes.notice,
      }}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="needs-validation" noValidate="">

          <SelectFieldV2
            name="invoiceType"
            placeholder="Choose Invoice Type"
            isMulti={false}
            options={types}
            label={(
              <>
                <span>Invoice Type</span>
                <abbr title="required">*</abbr>
              </>
            )}
          />

          <TextAreaField
            name="note"
            placeholder="Add a Note"
            row="10"
            label="Note"
            style={{ resize: 'vertical', height: '150px' }}
          />

          <div className="text-center mt100 mb30">
            <CancelPopupButton
              className="btn btn-primary btn-outline mr5 ml5 width-120"
              title="Cancel"
              onClick={onHide}
            />
            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Save'}
              className="btn btn-primary submit-button mr5 ml5 width-120"
              disabled={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}

EditForm.propTypes = {
  row: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
};
